<template>
    <div>
        <ls-modal :options="modals.howQuotingWorks" @onModalClose="closeModal('howQuotingWorks')">
            <div slot="header">
                <h3 class="ls-align--center ls-color--green">How Quoting Works</h3>
            </div>

            <div class="grid">
                <div class="grid__col-12">
                    <ol class="ls-how-quoting-works__list">
                        <li>
                            Select one or more services and fill in the details about your request.
                        </li>
                        <li>
                            A crew will be scheduled to inspect the work the next time they come out
                            to mow your lawn.
                        </li>
                        <li>
                            The crew will submit a quote within 24 hours of their visit. The quote
                            will include the service to be performed, a price, and a suggested date
                            to complete service.
                        </li>
                        <li>
                            After you approve the quote, the crew will be scheduled to complete the
                            service on the agreed upon service date.
                        </li>
                    </ol>
                </div>
            </div>

            <div slot="button" class="grid">
                <div class="grid__col-12">
                    <div>
                        <button
                            slot="button"
                            class="ls-float-right ls-button ls-button--white"
                            type="button"
                            @click="closeModal('howQuotingWorks')"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </ls-modal>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';

export default {
    components: {
        lsModal,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
.ls-how-quoting-works__list {
    font-size: rem(-1);
    padding-left: rem(7);
    padding-right: rem(7);

    @include max-screen(breakpoint(xs, max)) {
        padding-left: rem(4);
        padding-right: rem(0);
    }

    li {
        margin-bottom: rem(0);
        &:last-of-type {
            margin-bottom: 0;
        }
    }
}
</style>
